const STATUS_STYLES: Record<string, string> = {
  completed: 'bg-green-100 text-green-800',
  partial: 'bg-yellow-100 text-yellow-800',
  failed: 'bg-red-100 text-red-800',
  running: 'bg-blue-100 text-blue-800',
  pending: 'bg-gray-100 text-gray-600',
  cancelled: 'bg-gray-100 text-gray-600',
  retrying: 'bg-purple-100 text-purple-800',
  skipped: 'bg-gray-100 text-gray-400',
};

const STATUS_LABELS: Record<string, string> = {
  completed: '✅ 完成',
  partial: '⚠️ 部分失败',
  failed: '❌ 全部失败',
  running: '⏳ 运行中',
  pending: '⏸ 待运行',
  cancelled: '⛔ 已取消',
  retrying: '🔄 重试中',
  skipped: '⏭ 已跳过',
};

interface Props {
  status: string;
}

export function ExecutionStatusBadge({ status }: Props) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-600'}`}>
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
